import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import * as cashBalancesActions from '../actions/cash-balances.actions';
import { CashBalanceHttpService } from '../services/cash-balance-http.service';
import { CashBalancesModel } from '../models/cash-balances.model';
import { SubLedgerModel } from '../models/sub-ledger.model';
import { CashBalanceConfiguration } from '../models/cash-balance-configuration.model';
import { switchMap, map, catchError, mergeMap } from 'rxjs';

@Injectable()
export class CashBalanceEffects {

  constructor(
    private readonly actions$: Actions,
    private readonly cashBalanceHttpService: CashBalanceHttpService) {
  }

  
  load$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<cashBalancesActions.Load>(cashBalancesActions.LOAD),
    switchMap(action => {
      return this.cashBalanceHttpService.getCashBalances(action.context).pipe(
        map((balances: Array<CashBalancesModel>) => new cashBalancesActions.LoadComplete(balances, action.widgetId)),
        catchError(err => of(new cashBalancesActions.LoadError(err, action.widgetId)))
      );
    })));

  
  loadSubLedgers$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<cashBalancesActions.LoadSubLedgers>(cashBalancesActions.LOAD_SUB_LEDGERS),
    switchMap(() => {
      return this.cashBalanceHttpService.getSubLedgers().pipe(
        map((subledgers: Array<SubLedgerModel>) => new cashBalancesActions.LoadSubLedgersComplete(subledgers)),
        catchError(err => of(new cashBalancesActions.LoadSubLedgersError(err)))
      );
    })));

  
  loadConfiguration$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<cashBalancesActions.LoadConfiguration>(cashBalancesActions.LOAD_CONFIGURATION),
    mergeMap(action => {
      return this.cashBalanceHttpService.getCashBalanceConfiguration(action.widgetConfigurationId).pipe(
        map((configuration: CashBalanceConfiguration) =>
          new cashBalancesActions.LoadConfigurationComplete(configuration, action.widgetId)
        ),
        catchError(err => of(new cashBalancesActions.LoadConfigurationError(err, action.widgetId)))
      );
    })));

}
